import { ROADMAP_PILLARS } from "./constants";

export function pillarLabel(id) {
    return ROADMAP_PILLARS.find((p) => p.id === id)?.label || id;
}

export function horizonLabel(targetDateStr) {
    const t = new Date(targetDateStr + "T12:00:00");
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const target = new Date(t.getFullYear(), t.getMonth(), t.getDate());
    const diffDays = Math.round((target - today) / 86400000);

    if (diffDays < 0) return `${Math.abs(diffDays)}d overdue`;
    if (diffDays === 0) return "Today";
    if (diffDays <= 30) return "≤ 30 days";
    if (diffDays <= 90) return "This quarter";
    if (diffDays <= 365) return "Next 12 months";
    return "Long-term";
}

export function yearFromDate(targetDateStr) {
    return targetDateStr ? parseInt(targetDateStr.slice(0, 4), 10) : new Date().getFullYear();
}

export function quarterFromDate(targetDateStr) {
    if (!targetDateStr) return 1;
    const m = parseInt(targetDateStr.slice(5, 7), 10) - 1;
    return Math.floor(m / 3) + 1;
}

export function quarterLabel(q) {
    return `Q${q}`;
}

export function defaultTargetDate() {
    const d = new Date();
    d.setMonth(d.getMonth() + 2);
    return d.toISOString().slice(0, 10);
}

export function datePlusDays(days) {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
}

export function parseTags(str) {
    if (!str || !String(str).trim()) return [];
    return String(str)
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);
}

export function formatTags(arr) {
    return Array.isArray(arr) ? arr.join(", ") : "";
}

export function roadmapItemsToCsv(rows) {
    const headers = [
        "title",
        "target_date",
        "pillar",
        "status",
        "owner",
        "key_metric",
        "budget_estimate",
        "effort_band",
        "risk_level",
        "health",
        "progress_percent",
        "tags",
        "description",
        "success_criteria",
        "dependency_note",
        "review_date",
    ];
    const esc = (v) => {
        if (v == null) return "";
        const s = String(v).replace(/"/g, '""');
        return `"${s}"`;
    };
    const lines = [headers.join(",")];
    for (const r of rows) {
        lines.push(headers.map((h) => esc(r[h])).join(","));
    }
    return lines.join("\r\n");
}

export function downloadCsv(filename, csv) {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
